import React, { useState, useEffect } from "react";
import "./internshipcontrols.css";

const InternshipTable = () => {
  const [interns, setInterns] = useState([]);
  const [domains, setDomains] = useState([]);
  const [slots, setSlots] = useState([]);
  const [config, setConfig] = useState(null);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.FETCH_CONFIRMED_INTERNSHIPS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestType: "fetchInterns" }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Add domain/slot placeholders so we can track them
          const internsWithFields = data.interns.map((intern) => ({
            ...intern,
            domain: intern.domain || "",
            slot: "",
          }));
          setInterns(internsWithFields);
          setDomains(data.domains);
          setSlots(data.slots);
        } else {
          console.error("Error from backend:", data.message);
        }
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, [config]);

  // Handle checkbox toggle
  const toggleSelect = (internId) => {
    setSelected((prev) =>
      prev.includes(internId)
        ? prev.filter((id) => id !== internId)
        : [...prev, internId]
    );
  };

  // Update selected domain/slot in state
  const handleChange = (internId, field, value) => {
    setInterns((prev) =>
      prev.map((intern) =>
        intern.intern_id === internId ? { ...intern, [field]: value } : intern
      )
    );
  };

  // Confirm selected interns
  const handleConfirm = () => {
    if (selected.length === 0) {
      alert("Please select at least one intern to confirm.");
      return;
    }

    // Build payload: only selected interns with domain + slot
    const confirmData = interns
      .filter((intern) => selected.includes(intern.intern_id))
      .map((intern) => ({
        intern_id: intern.intern_id,
        domain: intern.domain,
        slot: intern.slot,
      }));

    console.log("Confirming interns:", confirmData);

    fetch(`${config.BASE_URL}${config.CONFIRM_INTERNSHIPS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ interns: confirmData }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Selected interns confirmed successfully!");
          setSelected([]);
        } else {
          alert("Error: " + data.message);
        }
      })
      .catch((err) => console.error("Error confirming interns:", err));
  };

  return (
    <div className="internship-table-container">
      <h2>Internship Applications</h2>
      <button
        className="confirm-button"
        style={{ marginBottom: "40px" }}
        onClick={handleConfirm}
      >
        Confirm Selected
      </button>

      <table className="internship-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Intern ID</th>
            <th>Name</th>
            <th>Domain</th>
            <th>Date</th>
            <th>Slot</th>
          </tr>
        </thead>
        <tbody>
          {interns.map((intern) => (
            <tr key={intern.intern_id}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.includes(intern.intern_id)}
                  onChange={() => toggleSelect(intern.intern_id)}
                />
              </td>
              <td>{intern.intern_id}</td>
              <td>{intern.name}</td>
              <td>
                <select
                  value={intern.domain}
                  onChange={(e) =>
                    handleChange(intern.intern_id, "domain", e.target.value)
                  }
                >
                  <option value="">Select Domain</option>
                  {domains.map((d, i) => (
                    <option key={i} value={d.internship_domain_name}>
                      {d.internship_domain_name}
                    </option>
                  ))}
                </select>
              </td>
              <td>{new Date(intern.added_at).toLocaleDateString()}</td>
              <td>
                <select
                  value={intern.slot}
                  onChange={(e) =>
                    handleChange(intern.intern_id, "slot", e.target.value)
                  }
                >
                  <option value="">Select Slot</option>
                  {slots.map((s, i) => (
                    <option key={i} value={s.slot_no}>
                      {s.slot_no} ({s.timings})
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InternshipTable;
